// The one demonstrable feature built on top of useRelayConnection: who else
// is connected to this published game right now. Deliberately minimal - a
// name pill list, no avatars, no status - since proving the relay is real
// end to end is the point, not building out a social surface.
import type { RelayPresenceEntry } from './useRelayConnection';

export function PresenceList({ presence }: { presence: RelayPresenceEntry[] }) {
  if (presence.length === 0) return null;
  return (
    <div
      style={{
        position: 'absolute',
        top: 54,
        left: 14,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        maxWidth: 200,
        background: 'rgba(6,6,8,0.72)',
        backdropFilter: 'blur(8px)',
        border: '1px solid var(--ss-border-soft)',
        borderRadius: 12,
        padding: '8px 12px',
        fontFamily: 'var(--ss-sans)',
        fontSize: 10.5,
        color: 'var(--ss-text-2)',
      }}
    >
      <span style={{ fontWeight: 600, letterSpacing: '0.08em', color: 'var(--ss-text-3)' }}>
        {presence.length} ONLINE
      </span>
      {presence.map((p) => (
        <span key={p.playerId} style={{ opacity: 0.85, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {p.name}
        </span>
      ))}
    </div>
  );
}
